<template>
  <div v-title="$route.meta.title"
       class="training-instruction-exam-record">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>考试培训管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/training/instruction' }">培训管理</el-breadcrumb-item>
        <el-breadcrumb-item>答卷列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <training-instruction-sub-heading :title="pageHeadingTitle"
                                      :entity-id="pageEntityId" />

    <div class="training-instruction-exam-record__card training-instruction-exam-record__card--search">
      <div class="training-instruction-exam-record__card-header"
           @click="searchExpanded = !searchExpanded">
        <span>搜索</span>
        <i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
      </div>

      <el-form v-show="searchExpanded"
               :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="left"
               size="small"
               class="training-instruction-exam-record__search-form"
               @submit.native.prevent="onSearch()">
        <div class="training-instruction-exam-record__search-grid">
          <el-form-item label="关键字"
                        prop="keyword">
            <el-input v-model="search.keyword"
                      placeholder="请输入真实姓名或ID"
                      clearable />
          </el-form-item>
          <el-form-item label="答卷状态"
                        prop="examination_status">
            <el-select v-model="search.examination_status"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option v-for="it in examStatusOptions"
                         :key="it.value"
                         :label="it.label"
                         :value="Number(it.value)" />
            </el-select>
          </el-form-item>
          <el-form-item label="用户类型"
                        prop="target_usertype">
            <el-select v-model="search.target_usertype"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option v-for="it in targetUserMaps"
                         :key="it.value"
                         :label="it.label"
                         :value="Number(it.value)" />
            </el-select>
          </el-form-item>
          <el-form-item label="来源"
                        prop="source_type">
            <el-select v-model="search.source_type"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option v-for="it in opts.sourceTypeMaps"
                         :key="it.value"
                         :label="it.label"
                         :value="Number(it.value)" />
            </el-select>
          </el-form-item>
          <el-form-item label="项目"
                        prop="projectid">
            <remote-select class="width-max"
                           clearable
                           id-key="number"
                           label-key="name"
                           value-key="id"
                           placeholder="请输入项目 名称/编号 进行搜索"
                           v-model="search.projectid"
                           :query-request="getProjectTable"
                           :find-request="getProjectDetail"
                           @change="search.batchid = null" />
          </el-form-item>
          <el-form-item label="批次"
                        prop="batchid">
            <remote-select class="width-max"
                           clearable
                           :disabled="!search.projectid"
                           id-key="number"
                           label-key="detail"
                           value-key="id"
                           placeholder="请输入批次 名称/编号 进行搜索"
                           v-model="search.batchid"
                           :query-request="(_) => getBatchTable(Object.assign({ projectid: search.projectid }, _))"
                           :find-request="getBatchDetail" />
          </el-form-item>
          <el-form-item label="省市区"
                        prop="regionids">
            <el-cascader v-model="search.regionids"
                         class="width-max"
                         :options="chinaAreaData"
                         :props="{ multiple: true, checkStrictly: true }"
                         filterable
                         clearable
                         placeholder="请选择省市区" />
          </el-form-item>
          <el-form-item label="提交时间"
                        prop="examination_submitted_at">
            <el-date-picker v-model="search.examination_submitted_at"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :picker-options="dateTimePickerRangeOptions"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="width-max"
                            :default-time="['00:00:00', '23:59:59']"
                            clearable />
          </el-form-item>
        </div>
        <div class="training-instruction-exam-record__search-actions">
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索</el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetSearch()">重置</el-button>
        </div>
      </el-form>
    </div>

    <div class="training-instruction-exam-record__card">
      <div class="training-instruction-exam-record__card-header"
           @click="listExpanded = !listExpanded">
        <span>答卷列表</span>
        <div class="training-instruction-exam-record__card-header-actions">
          <el-button type="text"
                     icon="el-icon-setting"
                     class="training-instruction-exam-record__header-action"
                     title="列配置"
                     @click.stop="openTableColumnConfigDialog" />
          <el-button type="text"
                     icon="el-icon-refresh"
                     class="training-instruction-exam-record__header-action"
                     @click.stop="onRefresh()" />
          <span class="training-instruction-exam-record__header-action">
            <i :class="listExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
          </span>
        </div>
      </div>

      <div v-show="listExpanded"
           class="training-instruction-exam-record__list-body">
        <div class="training-instruction-exam-record__table-wrap">
          <el-table :key="tableColumnRenderKey"
                    :data="table"
                    class="training-instruction-exam-record__table"
                    style="width: 100%">
            <el-table-column v-for="field in activeTableFields"
                             :key="field.key"
                             v-bind="getFieldColumnBind(field)">
              <template slot-scope="scope">
                <span v-if="field.slot === 'tag'">
                  <span v-if="field.formatter(scope.row)"
                        :class="['training-instruction-exam-record__tag', field.tagClass(scope.row)]">
                    {{ field.formatter(scope.row) }}
                  </span>
                  <span v-else
                        class="training-instruction-exam-record__empty">-</span>
                </span>
                <span v-else-if="field.slot === 'emptyText'">
                  <span v-if="scope.row[field.textKey]">{{ scope.row[field.textKey] }}</span>
                  <span v-else
                        class="training-instruction-exam-record__empty">-</span>
                </span>
                <template v-else-if="field.slot === 'subId'">
                  <template v-if="scope.row[field.idKey]">
                    <span>{{ scope.row[field.nameKey] }}</span>
                    <span class="training-instruction-exam-record__sub-id">/ {{ scope.row[field.idKey] }}</span>
                  </template>
                  <span v-else
                        class="training-instruction-exam-record__empty">-</span>
                </template>
                <template v-else>
                  {{ field.formatter ? field.formatter(scope.row) : scope.row[field.prop] }}
                </template>
              </template>
            </el-table-column>
            <el-table-column fixed="right"
                             label="操作"
                             width="100"
                             align="center">
              <template v-slot="scope">
                <span class="training-instruction-exam-record__action-link"
                      @click="$router.push(getDetailLink(scope.row))">查看详情</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination">
          <el-pagination background
                         @size-change="handleSizePageChange"
                         @current-change="handleCurrentPageChange"
                         :current-page="pagination.current_page"
                         :page-sizes="[20, 50, 100, 200]"
                         :page-size="pagination.per_page"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pagination.total" />
        </div>
      </div>
    </div>

    <table-column-config-dialog :visible.sync="tableColumnConfigDialogVisible"
                                :applied-columns="tableColumnAppliedConfig"
                                :definitions="fields"
                                @save="onTableColumnConfigSave" />
  </div>
</template>

<script>
import tableMixin from '@core/mixins/table-v3'
import dateTimePicker from '@core/mixins/dateTimePicker'
import tableColumnConfig from '@core/mixins/table-column-config'
import {
  opts,
  consts,
  TRAINING_INSTRUCTION_EXAM_RECORD_TABLE_COLUMN_STORAGE_KEY,
} from '@views/training/training-instruction-record.constants'
import { createTrainingInstructionExamRecordTableFields } from '@views/training/training-instruction-exam-record-table.fields'
import { opts as instructionOpts } from '@views/training/training-instruction.constants'
import TrainingInstructionSubHeading from '@views/training/components/TrainingInstructionSubHeading.vue'

const FIELD_COLUMN_BIND_KEYS = ['prop', 'label', 'width', 'minWidth', 'showOverflowTooltip', 'fixed', 'align']

export default {
  components: {
    TrainingInstructionSubHeading,
  },
  mixins: [tableMixin, dateTimePicker, tableColumnConfig],
  data () {
    return {
      searchExpanded: true,
      listExpanded: true,
      opts,
      targetUserMaps: instructionOpts.targetUserMaps,
      instruction: {
        id: 0,
        title: '',
      },
      examination: {
        id: 0,
        title: '',
      },
      chinaAreaData: [],
      search: {
        keyword: '',
        examination_status: null,
        target_usertype: null,
        source_type: null,
        projectid: null,
        batchid: null,
        regionids: [],
        examination_submitted_at: [],
      },
      searchFieldType: {
        examination_status: Number,
        target_usertype: Number,
        source_type: Number,
        projectid: Number,
        batchid: Number,
        regionids: Array,
        examination_submitted_at: Array,
      },
      examStatusOptions: opts.examinationStatusMaps.filter(it => it.value !== consts.EXAMINATION_STATUS_NOT_START),
      fields: createTrainingInstructionExamRecordTableFields(this),
    }
  },
  computed: {
    pageHeadingTitle () {
      if (this.instruction.id) {
        return `${this.$route.meta.title} · ${this.instruction.title}`
      }

      if (this.examination.id) {
        return `${this.$route.meta.title} · ${this.examination.title}`
      }

      return this.$route.meta.title || ''
    },
    pageEntityId () {
      if (this.instruction.id) {
        return this.instruction.id
      }

      if (this.examination.id) {
        return this.examination.id
      }

      return null
    },
    pageTitle () {
      const entityId = this.pageEntityId
      if (!entityId) {
        return this.pageHeadingTitle
      }

      return `${this.pageHeadingTitle} ID：${entityId}`
    },
    activeTableFields () {
      const fieldMap = _.keyBy(this.fields, 'key')
      return this.activeTableColumns
        .map(column => fieldMap[column.key])
        .filter(Boolean)
    },
  },
  created () {
    this.syncPageContext()
    this.getChinaAreaData()
  },
  beforeRouteUpdate (to, from, next) {
    this.syncPageContext(to)
    this.onSearch()
    next()
  },
  methods: {
    getTableColumnStorageKey () {
      return TRAINING_INSTRUCTION_EXAM_RECORD_TABLE_COLUMN_STORAGE_KEY
    },
    getFieldColumnBind (field) {
      return _.pick(field, FIELD_COLUMN_BIND_KEYS)
    },
    ...request.map([
      'getProjectTable',
      'getProjectDetail',
      'getBatchTable',
      'getBatchDetail',
    ]),
    loadInstruction () {
      if (!this.instruction.id) {
        return
      }
      const instructionId = this.instruction.id
      request.common('getTrainingInstruction', { id: instructionId }).then(({ data }) => {
        if (Number(this.instruction.id) !== Number(instructionId)) {
          return
        }
        this.instruction.title = data.title
      }).catch(() => {})
    },
    loadExamination () {
      if (!this.examination.id) {
        return
      }
      const examinationId = this.examination.id
      request.common('getTrainingExamination', { id: examinationId }).then(({ data }) => {
        if (Number(this.examination.id) !== Number(examinationId)) {
          return
        }
        this.examination.title = data.title
      }).catch(() => {})
    },
    syncPageContext (route = this.$route) {
      const instructionId = route.params.instructionId ? Number(route.params.instructionId) : 0
      const examinationId = route.params.examinationId ? Number(route.params.examinationId) : 0
      const queryTitle = route.query.title || ''

      if (instructionId > 0) {
        this.instruction.id = instructionId
        if (queryTitle) {
          this.instruction.title = queryTitle
        }
        this.loadInstruction()
      } else {
        this.instruction.id = 0
        this.instruction.title = ''
      }

      if (examinationId > 0) {
        this.examination.id = examinationId
        if (queryTitle) {
          this.examination.title = queryTitle
        }
        this.loadExamination()
      } else {
        this.examination.id = 0
        this.examination.title = ''
      }
    },
    getTableData (params) {
      delete params.id
      delete params.title
      delete params.recordId
      delete params.instructionId
      delete params.examinationId

      if (this.instruction.id) {
        params.training_instruction_id = this.instruction.id
      }
      if (this.examination.id) {
        params.training_examination_id = this.examination.id
      }
      return request.page('queryTrainingInstructionExamRecord', params)
    },
    getDetailLink (row) {
      const instructionId = row.training_instruction_id || this.instruction.id
      const title = this.instruction.title || row.instruction_title || ''
      return {
        path: `/training/instruction/exam-records/${instructionId}/detail/${row.id}`,
        query: { title },
      }
    },
    getExamStatusTagClass (status) {
      const value = Number(status)
      if (value === consts.EXAMINATION_STATUS_PASS) {
        return 'is-pass'
      }
      if (value === consts.EXAMINATION_STATUS_NOT_PASS) {
        return 'is-fail'
      }
      if (value === consts.EXAMINATION_STATUS_WAIT_SUBMIT) {
        return 'is-pending'
      }
      if (value === consts.EXAMINATION_STATUS_SUBMITTED) {
        return 'is-submitted'
      }
      return 'is-default'
    },
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    },
    getChinaAreaData () {
      request.alert('queryAllFormatted').then(({ data }) => {
        this.chinaAreaData = Array.isArray(data) ? data : (Array.isArray(data && data.data) ? data.data : [])
      }).catch(() => {
        this.chinaAreaData = []
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.training-instruction-exam-record {
  &__card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    overflow: hidden;

    & + & {
      margin-top: 16px;
    }
  }

  &__card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 24px;
    border-bottom: 1px solid #ebeef5;
    cursor: pointer;
    user-select: none;
    color: #606266;
    font-size: 14px;
    font-weight: 500;

    i {
      color: #909399;
    }
  }

  &__card-header-actions {
    display: flex;
    align-items: center;
    gap: 8px;

    ::v-deep .training-instruction-exam-record__header-action.el-button {
      min-width: 24px;
      padding: 0;
      margin: 0;
    }
  }

  &__header-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    margin: 0;
    color: #909399;
    flex-shrink: 0;
    line-height: 1;

    i {
      font-size: 14px;
    }
  }

  &__search-form {
    padding: 16px 24px 20px;
  }

  &__search-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px 16px;
  }

  &__search-actions {
    margin-top: 4px;
    padding-top: 4px;
  }

  &__list-body {
    padding: 0 16px 16px;
  }

  &__table-wrap {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
  }

  &__table {
    ::v-deep {
      th {
        background: #f5f7fa;
        color: #909399;
        font-size: 12px;
        font-weight: 500;
      }

      td {
        font-size: 14px;
        color: #303133;
      }

      .el-table__row:hover > td {
        background: #fafafa;
      }

      &::before {
        display: none;
      }
    }
  }

  &__tag {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
    white-space: nowrap;

    &.is-pass {
      background: #dcfce7;
      color: #15803d;
    }

    &.is-fail {
      background: #fee2e2;
      color: #dc2626;
    }

    &.is-pending {
      background: #fef9c3;
      color: #a16207;
    }

    &.is-submitted {
      background: #e0f2fe;
      color: #0369a1;
    }

    &.is-default {
      background: #f3f4f6;
      color: #6b7280;
    }
  }

  &__sub-id {
    margin-left: 4px;
    color: #c0c4cc;
    font-size: 12px;
    font-family: Menlo, Monaco, Consolas, monospace;
  }

  &__empty {
    color: #c0c4cc;
  }

  &__action-link {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 500;
    color: #409eff;
    cursor: pointer;

    &:hover {
      background: #ecf5ff;
    }
  }

  .pagination {
    margin: 16px auto 0;
    text-align: center;
  }
}

@media (max-width: 1200px) {
  .training-instruction-exam-record {
    &__search-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}

@media (max-width: 768px) {
  .training-instruction-exam-record {
    &__search-grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>

<style lang="scss">
.training-instruction-exam-record__search-form {
  .el-form-item {
    margin-bottom: 0;
  }

  .el-form-item__label {
    color: #606266;
    font-size: 13px;
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/training/pages/instruction/TrainingInstructionExamRecordTable.vue